
















import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import { SectionCore } from '@/mixins/sectionCore'
import { IFormContact } from '@/contracts/IFormContactBlock'
import SectionBasic from '@/components/SectionBasic.vue'
import BlockRequisites from '@/components/BlockRequisites.vue'

@Component
class SectionRequisites extends mixins(SectionCore) {
  @Prop() readonly isReverse: boolean = false
  @Prop() readonly docUrl: String = ''
  @Prop() readonly buttonText: String = ''
  @Prop() readonly list: ReadonlyArray<IFormContact> = []
}

export default defineComponent({
  name: 'SectionRequisites',
  components: {
    SectionBasic,
    BlockRequisites,
  },
  props: SectionRequisites.options.props,
})
